export function setImpersonateUserStatus(status) {
  return {
    type: 'IMPERSONATE/SET_STATUS',
    payload: status
  };
}
